module.exports = __webpack_public_path__ + "img/logo.30329d03.png";